module.exports = __webpack_public_path__ + "static/media/brand-logo.84e03128.svg";